import { render, staticRenderFns } from "./VShortKey.vue?vue&type=template&id=511f9977&"
import script from "./VShortKey.vue?vue&type=script&lang=js&"
export * from "./VShortKey.vue?vue&type=script&lang=js&"
import style0 from "./VShortKey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports